import React from "react";
import { useLocation } from "react-router-dom";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_M4_EdmondsKarp = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <DAAModuleSubtopic
      title="Edmonds-Karp Algorithm - Maximum Flow using BFS"
      videos={["https://www.youtube.com/embed/tTP94yZTdD0", "https://www.youtube.com/embed/asDetbDcmJw"]}
      takeaways={[
        { text: "Uses BFS to find shortest augmenting paths." },
        { text: "Edmonds-Karp is Ford-Fulkerson with BFS instead of DFS." },
        { text: "Always finds the shortest augmenting path (in terms of edges)." },
        { text: "Guarantees that the number of augmenting paths is O(VE)." },
        { text: "Guaranteed polynomial time complexity: O(VE²)." },
        { text: "Better for large graphs than standard Ford-Fulkerson." },
        { text: "BFS ensures fewer augmenting paths than DFS, preventing infinite loops." },
        { text: "Example Use Case: Telecommunication networks, road networks, or wireless networks where finding an optimal augmenting path is essential." },
      ]}
      questions={[
        "Write an Edmonds-Karp algorithm, and compute the maximum flow in the network N and analyze its complexity.",
        "In a wireless network, node S wishes to send some packets to node T, but S and T are not directly connected. We need to find the path that can transfer the most packets while satisfying the capacity constraints of the edges. The network is represented as a graph, G = (V,E). Design an algorithm with complexity O(VE²) and find the maximum number of packets transferred from node S to node T using the given graph.",
        "The capacity matrix for a flow network is given below. The first augmenting path found using the Edmonds-Karp algorithm for the graph is 0-1-2-4-5. Is this correct or not? Justify your answer.",
      ]}
      exampleVideos={[]}
      subtopics={subtopics}
      subjectPath={subjectPath}
    />
  );
};

export default DAA_M4_EdmondsKarp;
